// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59422ecc","453":"ad5c3fb3","455":"ec42c786","977":"a00a6603"}[chunkId] + ".chunk.js";
};